import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Box, Button, Grid, Typography, Card, CardContent } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import RenderMuiSelect from 'src/shared/components/form/MuiSelect';
import renderMultiSelectField from 'src/shared/components/form/MultiSelect';
import MuiTextField from 'src/shared/components/form/MuiTextField';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const required = value => value ? undefined : 'Required';

const TerritoryModalAddOrUpdate = ({ handleSubmit, regionId }) => {

    useEffect(() => {
        getAllEmiratesDetails();
    }, []);

    const [isAreaWiseList, setAreaWiseList] = useState([]);
    const [isStateList, setateList] = useState([]);

    const getAllEmiratesDetails = async () => {
        let stateList = [];
        try {
            const response = await PndRestApi.GetAllEmiratesDetails();
            if (response.status === 200 && response.data.status === 200) {
                response.data.data.map(item => {
                    stateList.push({ "label": item.stateName, "value": item.stateCode });
                });
                setateList(stateList);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        }
    };

    const getAreas = async (event) => {
        let areaListArray = [];
        if (event?.value) {
            try {
                const response = await PndRestApi.GetStateWiseAreas(event.value);
                if (response.status === 200 && response.data.status === 200) {
                    response.data.data.map(item => {
                        areaListArray.push({ "label": item.territoryName, "value": item.territoryAreaId });
                    });
                    setAreaWiseList(areaListArray);
                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${response.data.status}`,
                        `Message:${response.data.message}`,
                    );
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: 500`,
                    ERROR_MESSAGES.tryCatchError,
                );
            }
        } else {
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 204`,
                `Message: No Data Found`,
            );
        }
    };

    return (
        <form className="form-animated" onSubmit={handleSubmit}>
            <Card elevation={0} sx={{ border: 'none', borderRadius: 2 }}>
                <CardContent sx={{ p: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                    TERRITORY NAME <span style={{ color: 'red' }}>*</span>
                                </Typography>
                            </Box>
                            <Field
                                name="regionName"
                                component={MuiTextField}
                                type="text"
                                placeholder="Enter Territory Name"
                                validate={[required]}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Box sx={{ mb: 1 }}>
                                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                    TERRITORY CODE <span style={{ color: 'red' }}>*</span>
                                </Typography>
                            </Box>
                            <Field
                                name="regionCode"
                                component={MuiTextField}
                                type="text"
                                placeholder="Enter Territory Code"
                                validate={[required]}
                            />
                        </Grid>

                        {!regionId && (
                            <Grid item xs={12} md={6}>
                                <Box sx={{ mb: 1 }}>
                                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                        EMIRATES <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Box>
                                <Field
                                    validate={[required]}
                                    name="stateInfo"
                                    component={RenderMuiSelect}
                                    type="text"
                                    options={isStateList}
                                    placeholder="Select Emirates"
                                    onChange={event => {
                                        getAreas(event);
                                    }}
                                />
                            </Grid>
                        )}

                        {!regionId && (
                            <Grid item xs={12}>
                                <Box sx={{ mb: 1 }}>
                                    <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                        AREAS <span style={{ color: 'red' }}>*</span>
                                    </Typography>
                                </Box>
                                <Field
                                    validate={[required]}
                                    name="areaInfo"
                                    component={renderMultiSelectField}
                                    type="text"
                                    options={isAreaWiseList}
                                    placeholder="Select Areas to include in this Territory"
                                />
                            </Grid>
                        )}
                    </Grid>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, pt: 2, borderTop: '1px solid #f1f5f9' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            startIcon={<SaveIcon />}
                            sx={{
                                borderRadius: '10px',
                                textTransform: 'none',
                                fontWeight: 600,
                                px: 4,
                                py: 1.2,
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                            }}
                        >
                            Submit
                        </Button>
                    </Box>
                </CardContent>
            </Card>
        </form>
    );
};

TerritoryModalAddOrUpdate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    regionId: PropTypes.any,
};

const mapStateToProps = (state, data) => {
    let initialValues = {};
    if (data && data?.dataInfo) {
        initialValues = {
            regionCode: data?.dataInfo?.regionCode,
            regionName: data?.dataInfo?.regionName,
            regionId: data?.dataInfo?.regionId
        };
    }
    return {
        initialValues
    };
};

export default connect(mapStateToProps)(reduxForm({ form: 'TerritoryModalAddOrUpdateForm', enableReinitialize: true })(TerritoryModalAddOrUpdate));